import { CASCO, KGFB, MAPFREA } from '../../../../modules/Const';

export default {
    methods: {
        ovbVanKotheto(modozat) {
            const kothetoModozatok = this.$store.getters.ovbKothetoModozatok;
            switch (modozat) {
            case 'kgfb':
                return this.reloaded ? this.vanGfb : kothetoModozatok.includes(KGFB);
            case 'casco':
                return this.reloaded ? this.vanCasco : kothetoModozatok.includes(CASCO);
            default:
                throw new Error('ovbVanKotheto error');
            }
        },
    },

    computed: {
        kothetCasco() {
            return this.$store.getters.getBroker?.insuranceCompanies?.casco?.length > 0;
        },
        kothetGfb() {
            return this.$store.getters.getBroker?.insuranceCompanies?.gfb?.length > 0;
        },
        kothetAssistance() {
            return this.$store.getters.getBroker?.insuranceCompanies?.gfb_aszisztencia?.length > 0;
        },
        vanCasco() {
            return this.$store.getters.modozat
                ? this.$store.getters.modozat.includes(CASCO)
                : false;
        },
        vanGfb() {
            return this.$store.getters.modozat
                ? this.$store.getters.modozat.includes(KGFB)
                : false;
        },
        vanAssistance() {
            return this.$store.getters.modozat
                ? this.$store.getters.modozat.includes(MAPFREA)
                : false;
        },
        vanValasztottCasco() {
            return this.$store.getters.valasztottCascoBiztosito > 0;
        },
        valasztottCascoBiztosito() {
            if (this.vanValasztottCasco) {
                return this.$store.getters.valasztottCascoBiztosito;
            }
            return null;
        },
        vanValasztottGfb() {
            return this.$store.getters.valasztottKgfbBiztosito > 0;
        },
        valasztottGfbBiztosito() {
            if (this.vanValasztottGfb) {
                return this.$store.getters.valasztottKgfbBiztosito;
            }
            return null;
        },
        vanValasztottAssistance() {
            return this.$store.getters.valasztottAssistanceBiztosito > 0;
        },
        valasztottAssistanceBiztosito() {
            if (this.vanValasztottAssistance) {
                return this.$store.getters.valasztottAssistanceBiztosito;
            }
            return null;
        },
        egyuttkotes() {
            return this.$store.getters.modozat.includes(KGFB) && this.$store.getters.modozat.includes(CASCO);
        },
        reloaded() {
            return (this.$store.getters.tarifaData.id && this.$store.getters.tarifaData.id !== 0)
                || this.$store.getters.token;
        },
    },
};
